// Mui Imports
import { Add } from "@mui/icons-material";
import { Button, Skeleton, Stack } from "@mui/material";

// React Imports
import { useEffect, useState } from "react";

// Project Imports
import { getDisbursementApplications } from "apis/controllers/disbursements";
import { useLoading } from "src/hooks/useLoading";
import DisbursementApplicationsGrid from "./Components/DisbursementApplicationsGrid";
import NewDisbursementApplicationPanel from "./Components/NewDisbursementApplicationPanel";
import "./DisbursementApplications.css";

const DisbursementApplications = () => {
  const [newDisbursementApplication, setNewDisbursementApplication] =
    useState(false);
  const [disbursementApplications, setDisbursementApplications] =
    useState(false);
  const { setLoading } = useLoading();

  const fetchDisbursementApplications = async () => {
    setLoading(true);
    try {
      const res = await getDisbursementApplications();
      setDisbursementApplications(res?.data);
    } catch {
      setDisbursementApplications([]);
    } finally {
      setLoading(false);
    }
    setLoading(false);
  };

  useEffect(() => {
    setLoading(true);
    fetchDisbursementApplications();
  }, []);

  return (
    <div className="disbursement-applications-container">
      <h2 className="bordered-heading-2">Οι Αιτήσεις Εκταμίευσής μου</h2>
      <Button
        onClick={() => setNewDisbursementApplication((prev) => !prev)}
        variant="contained"
        startIcon={<Add />}
        sx={{ width: 240 }}
      >
        Νέα Αίτηση Εκταμίευσης
      </Button>
      {disbursementApplications ? (
        <>
          <NewDisbursementApplicationPanel
            visible={newDisbursementApplication}
          />
          <DisbursementApplicationsGrid
            disbursementApplications={disbursementApplications}
          />
        </>
      ) : (
        <Stack>
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
          <Skeleton />
        </Stack>
      )}
    </div>
  );
};

export default DisbursementApplications;
